import moment from 'moment';

import type {StudentAssignmentsFilters} from './StudentAssignment.types';
import type {Value as DropdownValue} from './AssignmentStatusDropdown';

// The number of days before and after the current day that to-do assignments will be scoped to
const TO_DO_PROXIMITY = 30;

export default function getFilters(
  classroomId: string | undefined,
  dropdownValue: DropdownValue
): StudentAssignmentsFilters {
  const filters: StudentAssignmentsFilters = {
    hasStarted: {eq: true}
  };

  if (classroomId !== undefined) {
    filters.classrooms = {
      id: {eq: classroomId}
    };
  }

  if (dropdownValue === 'closed') {
    filters.isOpen = {eq: false};
  } else if (dropdownValue === 'open') {
    filters.isOpen = {eq: true};
  } else if (dropdownValue === 'toDo') {
    filters.dueDate = {
      greaterThanOrEqual: moment().subtract(TO_DO_PROXIMITY, 'days').startOf('day').format(),
      lessThanOrEqual: moment().add(TO_DO_PROXIMITY, 'days').endOf('day').format()
    };
    filters.hasSubmitted = {eq: false};
    filters.isOpen = {eq: true};
  }

  return filters;
}
